import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BookingForm.css';
import Header from './Header';

const BUTTONS = [
  "Confirm Bookings",
  "View Bookings",
  "Book Lesson",
  "Book School",
  "School Schedule",
  "Lesson Schedule",
  "Book Single Lesson",
  "Regular Schedule",
  
  //"Add Clinic",
  //"Book Clinic",
  //"Email Clients" // renamed/added entry
];

// Get userType from localStorage (supports multiple shapes)
function getUserType() {
  try {
    const raw = localStorage.getItem('currentUser') || localStorage.getItem('user');
    const user = raw ? JSON.parse(raw) : null;
    const type = user?.userType ?? user?.roleId ?? user?.type ?? user?.role;
    return type != null ? Number(type) : null;
  } catch {
    return null;
  }
}

function AdminDashboard() {
  const navigate = useNavigate();
  const userType = getUserType();

  // If userType == 27 only show booking buttons
  // If userType == 29 show all except "Book Lesson"
  const VISIBLE_BUTTONS = React.useMemo(() => {
    if (userType === 27) return ["Book Lesson", "Book School","View Bookings"];
    if (userType === 29) return BUTTONS.filter(b => b !== "Reports" && b !== "Book Clinic");
    return BUTTONS;
  }, [userType]);

  // When back button is pressed, log out (navigate to home/login)
  const handleLogout = () => {
    navigate('/');
  };

  // Handle button clicks
  const handleButtonClick = (label) => {
    if (label === "Confirm Bookings") {
      navigate('/confirm-bookings');
    }
    if (label === "View Bookings") {
      navigate('/view-bookings');
    }
    if (label === "Lesson Schedule") {
      navigate('/lesson-schedule', { state: { school: false } });
    }
    if (label === "School Schedule") {
      navigate('/lesson-schedule', { state: { school: true } });
    }
    if (label === "Book Lesson") {
      navigate('/bookingCalendar', { state: { school: false } });
    }
    if (label === "Book School") {
      navigate('/bookingCalendar', { state: { school: true } });
    }
    if (label === "Regular Schedule") {
      navigate('/regular-schedule');
    }

    if (label === "Book Single Lesson") {
      navigate('/bookingCalendar', { state: { school: false, singleLesson: true } });
    }

    // Add more navigation logic for other buttons if needed
  };

  return (
    <div className="bookingform-page" style={{ minHeight: "100vh" }}>
      <div className="bookingform-form main-container" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Header onBack={handleLogout} />
        <h2 style={{ margin: "24px 0 32px 0" }}>Dashboard</h2>
        <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", gap: "18px" }}>
          {VISIBLE_BUTTONS.map(label => (
            <button
              key={label}
              onClick={() => handleButtonClick(label)}
              style={{
                width: "90%",
                maxWidth: 320,
                minWidth: 180,
                padding: "4px 0",
                fontSize: "1.1rem",
                fontWeight: 700,
                background: "#282c34",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(40,44,52,0.08)",
                transition: "background 0.2s"
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;